import type { SvgComponent } from '@/types/SvgComponent';

export const ThreeDIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_280_194)">
        <path
          d="M3.06592 7.21118L12.0003 12.1012L20.9347 7.21118"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.36 2.34351L20.61 6.86039C20.7278 6.92484 20.8261 7.01974 20.8947 7.13518C20.9633 7.25062 20.9997 7.38236 21 7.51664V16.4829C20.9997 16.6172 20.9633 16.7489 20.8947 16.8643C20.8261 16.9798 20.7278 17.0747 20.61 17.1391L12.36 21.656C12.2496 21.7164 12.1258 21.7481 12 21.7481C11.8742 21.7481 11.7504 21.7164 11.64 21.656L3.39 17.1391C3.2722 17.0747 3.17386 16.9798 3.10526 16.8643C3.03666 16.7489 3.0003 16.6172 3 16.4829V7.51664C3.0003 7.38236 3.03666 7.25062 3.10526 7.13518C3.17386 7.01974 3.2722 6.92484 3.39 6.86039L11.64 2.34351C11.7504 2.28312 11.8742 2.25146 12 2.25146C12.1258 2.25146 12.2496 2.28312 12.36 2.34351Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.1023V21.7501"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_280_194">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
